// src/app/store.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from '../features/auth/authSlice';
import userReducer from '../features/users/userSlice';
import baseReducer from '../features/base/baseSlice'; 
import teamsReducers from '../features/teams/teamsSlice';
import locationReducer from '../features/location/locationSlice';
import departmentReducer from '../features/department/departmentSlice';
import pipelineReducer from '../features/pipeline/pipelineSlice';
import pipelineStagesReducer from '../features/pipelineStages/pipelineStagesSlice';
import tagsReducer from '../features/tags/tagsSlice';
import questionnaireReducer from '../features/questionnaire/questionnaireSlice';
import questionStepsReducers from "../features/questionSteps/questionStepSlice"
import emailReducers from '../features/email/emailSlice';
import jobReducers from '../features/job/jobSlices';
import layoutReducer from '../features/job/layoutSlice';
import jobApplicationReducers from '../features/jobApplication/JobApplicationSlice';
import ApplicationDataReducers from '../features/ApplicationData/ApplicationDataSlice';
import uiReducer from '../features/ui/uiSlice';
import chatReducer from '../features/chat/chatSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  base: baseReducer,
  user: userReducer,
  teams: teamsReducers,
  location: locationReducer,
  department : departmentReducer,
  pipeline: pipelineReducer,
  pipelineStages: pipelineStagesReducer,
  tags: tagsReducer,
  questionnaire : questionnaireReducer,
  questionSteps : questionStepsReducers,
  email : emailReducers,
  job : jobReducers,
  layout: layoutReducer,
  jobApplication : jobApplicationReducers,
  ApplicationData : ApplicationDataReducers,
  ui: uiReducer,
  chat: chatReducer,

});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export const persistor = persistStore(store);

// Define types for state and dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;